import { Link } from "react-router-dom";
import { MapPin, Phone, MessageCircle } from "lucide-react";
import { Logo } from "./Logo";
import { ADDRESS, NAV_LINKS, PHONE, PHONE_TEL, waLink } from "@/lib/site";
import { useScrollTo } from "./SmoothScroll";

const SERVICES = ["Business Websites", "E-Commerce Websites", "Clinic & Hospital Websites", "Salon & Beauty Websites", "Restaurant Websites", "Real Estate Websites"];

export const Footer = () => {
  const scrollTo = useScrollTo();
  return (
    <footer data-testid="site-footer" className="relative mt-10 border-t border-white/5 pt-20">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 sm:px-8 md:grid-cols-2 lg:grid-cols-[1.4fr_1fr_1fr_1.2fr]">
        <div>
          <Logo />
          <p className="font-display mt-6 max-w-xs text-lg leading-snug text-white">Professional Websites. Affordable Prices. <span className="text-gold-grad">Powerful Results.</span></p>
          <p className="mt-4 max-w-xs text-sm text-slate-400">Website designing &amp; development for businesses in Noida, Delhi NCR and nearby markets.</p>
        </div>
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.25em] text-[var(--gold)]">Quick Links</p>
          <ul className="mt-6 space-y-3">
            {NAV_LINKS.map((l) => (
              <li key={l.id}><a href={`/#${l.id}`} onClick={(e) => scrollTo(l.id, e)} data-testid={`footer-link-${l.id}`} className="text-sm text-slate-300 transition-colors hover:text-white">{l.label}</a></li>
            ))}
          </ul>
        </div>
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.25em] text-[var(--gold)]">Services</p>
          <ul className="mt-6 space-y-3">
            {SERVICES.map((s) => (
              <li key={s}><a href="/#services" onClick={(e) => scrollTo("services", e)} className="text-sm text-slate-300 transition-colors hover:text-white">{s}</a></li>
            ))}
          </ul>
        </div>
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.25em] text-[var(--gold)]">Get in touch</p>
          <ul className="mt-6 space-y-4 text-sm text-slate-300">
            <li className="flex gap-3"><MapPin className="mt-0.5 h-4 w-4 shrink-0 text-[var(--gold)]" />{ADDRESS}</li>
            <li><a href={PHONE_TEL} data-testid="footer-phone-link" className="flex gap-3 hover:text-white"><Phone className="h-4 w-4 text-[var(--gold)]" />{PHONE}</a></li>
            <li><a href={waLink()} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp-link" className="flex gap-3 hover:text-white"><MessageCircle className="h-4 w-4 text-[var(--gold)]" />WhatsApp us</a></li>
          </ul>
        </div>
      </div>
      <div className="font-display pointer-events-none mt-16 select-none overflow-hidden text-center text-[22vw] font-semibold leading-[0.8] tracking-tighter text-white/[0.03] lg:text-[16vw]">PRATAP</div>
      <div className="border-t border-white/5">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-4 px-5 py-6 text-xs text-slate-400 sm:flex-row sm:px-8">
          <p>© {new Date().getFullYear()} Pratap Group. All rights reserved.</p>
          <div className="flex gap-6">
            <Link to="/privacy" data-testid="footer-privacy-link" className="hover:text-white">Privacy Policy</Link>
            <Link to="/terms" data-testid="footer-terms-link" className="hover:text-white">Terms &amp; Conditions</Link>
            <Link to="/admin" data-testid="footer-admin-link" className="hover:text-white">Admin</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
